import React from "react";

import { configureAnchors } from "react-scrollable-anchor";
import ScrollableAnchor from "react-scrollable-anchor";

import { CHALLENGE } from "App/Routes";
import ChallengeCard from "components/Topic/ChallengeCard";
import Link from "components/shared/Link/Link";

/*
  Offset accounts for topbar (50px), and half of challenge icon with buffer (~25px).
  Scroll duration at 1 ms more or less removes the animation
*/
configureAnchors({ offset: -75, scrollDuration: 1 });

class CustomChallengeCard extends ChallengeCard {
  renderCard(props) {
    let img = this.props.img;

    return (
      <ScrollableAnchor id={"challenge" + this.props.id}>
        <div
          className="challenge-card lighttext box-sizing-border-box-all"
          style={{
            backgroundImage:
              "linear-gradient(rgba(20,20,20,0.3),rgba(255,255,255,0),rgba(255,255,255,0),rgba(255,255,255,0),rgba(255,255,255,0),rgba(20,20,20,0.3)), url(" +
              img +
              ")"
          }}
        >
          <Link
            className="challenge-card-link-overlay"
            to={CHALLENGE.format(props.id)}
          />
          <Link className="icons-wrap" to={CHALLENGE.format(props.id)}>
            <div className="icons">
              <div
                className={"challengeicon icon " + this.setChallengeTypeClass()}
              />
              {this.props.points !== 0 ? (
                <div className="challengeicon">
                  <div className="points">
                    +{this.props.points.abbreviateNumber()}
                  </div>
                </div>
              ) : null}
            </div>
          </Link>
          {/*
            Custom: remove challenge title in challenge card, removed stats
           */}
          <div className="pure-u-g challengecard-bottom">
            <div className="pure-u-8-24 stats-wrap">
              {/* this.renderStats() */}
            </div>
            <div className="pure-u-1-24" />
            <div className="pure-u-15-24 button-wrap">
              {this.renderButtons()}
            </div>
          </div>
        </div>
      </ScrollableAnchor>
    );
  }

  /* Custom: removed renderMenuDropdownButton */
  renderFlashcardButtons() {
    return (
      <span id="flashcard-buttons">
        {this.renderBookmarkButton()}
        {this.renderLikeButton()}
        {/* this.renderMenuDropdownButton() */}
      </span>
    );
  }

  /* Custom: removed renderMenuDropdownButton */
  renderChallengeButtons() {
    return (
      <span id="challenge-buttons">
        <div>
          {this.renderBookmarkButton()}
          {/* this.renderMenuDropdownButton() */}
        </div>
        <div>
          <button
            className={
              "button medium inline button-challenge-card" +
              (this.props.isCompleted || this.props.isExpired
                ? " inactive"
                : " cta")
            }
          >
            {this.renderActionButton()}
          </button>
        </div>
      </span>
    );
  }
}

export default CustomChallengeCard;
